// extracted by mini-css-extract-plugin
module.exports = {"_boxOne":"timeline__boxOne__1MScm"};